import Sidebar from "@/components/layout/Sidebar";
import CloudsBackground from "@/components/layout/CloudsBackground";

export default function AppShell({ children, title, subtitle, actions }) {
  return (
    <>
      <CloudsBackground />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 min-w-0 min-h-screen overflow-x-hidden">
          <header className="sticky top-0 z-10 wv-topbar">
            <div className="max-w-7xl xl:max-w-[1400px] 2xl:max-w-[1600px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row md:items-end md:justify-between gap-4 md:gap-6">
              <div className="min-w-0">
                <h1 className="text-3xl md:text-4xl font-light tracking-tight" style={{ fontFamily: "Outfit" }} data-testid="page-title">
                  {title}
                </h1>
                {subtitle && (
                  <p className="mt-1 text-sm text-[var(--wv-text-2)] max-w-2xl">{subtitle}</p>
                )}
              </div>
              {actions && <div className="flex items-center gap-3 flex-wrap md:justify-end shrink-0">{actions}</div>}
            </div>
          </header>
          <div className="max-w-7xl xl:max-w-[1400px] 2xl:max-w-[1600px] mx-auto px-6 md:px-10 py-8">{children}</div>
        </main>
      </div>
    </>
  );
}
